import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import routes from './routes'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { AccountModel, setUser } from './stores/UserModel'
import GlobalState, { setLang } from './stores/GlobalState'
import { runInAction } from 'mobx'
import { getLocaleMenu } from './stores/ContentState'

import './mocks/polifils'
const App = observer(() => {
  const headerContent = useRef(null)
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    if (window.location) {
      const DOMAIN = 'https://personal.novaposhtaglobal.ua/post-react'

      runInAction(() => {
        GlobalState.domain = DOMAIN
      })
      setLoading(true)
    }
    getLocaleMenu()
    if (localStorage.getItem('user-np') || sessionStorage.getItem('user-np')) {
      if (localStorage.getItem('user-np')?.length) {
        runInAction(() => {
          AccountModel.email = localStorage.getItem('user-np')
        })
      }
      if (sessionStorage.getItem('user-np')?.length) {
        runInAction(() => {
          AccountModel.email = sessionStorage.getItem('user-np')
        })
      }
    }
  }, [])
  useEffect(() => {
    let vh = window.innerHeight * 0.01
    ;(document.querySelector('#root') as any)?.style?.setProperty(
      '--viewport-height',
      `${vh}px`,
    )
    window.addEventListener('resize', function (e) {
      let vh = window.innerHeight * 0.01

      ;(document.querySelector('#root') as any)?.style?.setProperty(
        '--viewport-height',
        `${vh}px`,
      )
    })
  }, [])

  if (!isLoading) return <></>

  return (
    <GoogleOAuthProvider clientId="409040694017-4e7v5tj5ucm3v0obnrtf3hudbm60rjis.apps.googleusercontent.com">
      <Router>
        <div ref={headerContent}></div>

        <Routes>
          {routes.map((route, idx) => (
            <Route key={idx} path={route.path} element={route.component} />
          ))}
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  )
})

export default App
